import moment from "moment";
import { User } from "src/app/core/models/auth.models";
import { CompanyModel } from "src/app/core/models/company.model";
import { ProposalModel } from "./proposal.model";
import { RequestVersionModel, Status } from "./request-version.model";

export class ContractModel {
  public id: number;

  public startDate: Date;
  public endDate: Date;

  public customerSignature: string | null;
  public partnerSignature: string | null;
  public memberSignature: string | null;

  public status: Status;
  public version: number;

  public revisionReason: string | null;
  public rejectedReason: string | null;
  
  public uploadedFiles: any[];

  public templateId: number | null;
  public projectRequestVersionId: number | null;
  public proposalId: number | null;
  public partnerId: number | null;
  public customerId: number | null;

  public projectRequestVersion: RequestVersionModel | null;
  public proposal: ProposalModel | null;
  public partner: CompanyModel | null;
  public customer: CompanyModel | null;

  public createdAt: Date;
  public updatedAt: Date;

  constructor($obj?: any) {
    this.id = $obj && $obj.id ? $obj.id : '#new' + moment().valueOf();

    this.startDate = $obj && $obj.startDate ? new Date($obj.startDate) : new Date();
    this.endDate = $obj && $obj.endDate ? new Date($obj.endDate) : new Date();

    this.customerSignature = $obj && $obj.customerSignature ? $obj.customerSignature : null;
    this.partnerSignature = $obj && $obj.partnerSignature ? $obj.partnerSignature : null;
    this.memberSignature = $obj && $obj.memberSignature ? $obj.memberSignature : null;

    this.status = $obj && $obj.status ? $obj.status : Status.Draft;
    this.version = $obj && $obj.version ? $obj.version : 1;

    this.revisionReason = $obj && $obj.revisionReason ? $obj.revisionReason : null;
    this.rejectedReason = $obj && $obj.rejectedReason ? $obj.rejectedReason : null;

    this.uploadedFiles = $obj && $obj.uploadedFiles ? $obj.uploadedFiles : null;

    this.templateId = $obj && $obj.templateId ? $obj.templateId : null;
    this.projectRequestVersionId = $obj && $obj.projectRequestVersionId ? $obj.projectRequestVersionId : $obj && $obj.projectRequestVersion ? $obj.projectRequestVersion.id : null;
    this.proposalId = $obj && $obj.proposalId ? $obj.proposalId : $obj && $obj.proposal ? $obj.proposal.id : null;
    this.partnerId = $obj && $obj.partnerId ? $obj.partnerId : $obj && $obj.partner ? $obj.partner.id : null;
    this.customerId = $obj && $obj.customerId ? $obj.customerId : $obj && $obj.customer ? $obj.customer.id : null;

    this.projectRequestVersion = $obj && $obj.projectRequestVersion ? new RequestVersionModel($obj.projectRequestVersion) : null;
    this.proposal = $obj && $obj.proposal ? new ProposalModel($obj.proposal) : null;
    this.partner = $obj && $obj.partner ? new CompanyModel($obj.partner) : null;
    this.customer = $obj && $obj.customer ? new CompanyModel($obj.customer) : null;

    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();
  }

  get isDraft(): boolean { return this.status === Status.Draft ? true : false; }
  get isSubmitted(): boolean { return this.status === Status.Submitted ? true : false; }
  get isPending(): boolean { return this.status === Status.Pending ? true : false; }
  get isApproved(): boolean { return this.status === Status.Approved ? true : false; }
  get isRejected(): boolean { return this.status === Status.Rejected ? true : false; }
  get isDraftOrSubmitted(): boolean { return this.isDraft || this.isSubmitted ? true : false; }
  get isInRevision(): boolean { return this.status === Status.Revision ? true : false; }
  get isMissingSignatures(): boolean {
    return this.memberSignature === null || this.partnerSignature === null || this.customerSignature === null ? true : false;
  }

  showApproveBtn(currentUser: User | null): boolean {
    const checkUserSigned = (currentUser?.isAdmin || currentUser?.isMember) && this.memberSignature !== null ? true :
      currentUser?.isPartner /* && currentUser.id === this.partnerIdP */ && this.partnerSignature !== null ? true :
        currentUser?.isCustomer /* && currentUser.id === this.customerId */ && this.customerSignature !== null ? true : false;
    return (this.isSubmitted || this.isPending || this.isInRevision) && (!currentUser || !checkUserSigned) ? true : false;
  }

  showRejectBtn(currentUser: User | null): boolean {
    const checkUserSigned = (currentUser?.isAdmin || currentUser?.isMember) && this.memberSignature !== null ? true :
      currentUser?.isPartner /* && currentUser.id === this.partnerIdP */ && this.partnerSignature !== null ? true :
        currentUser?.isCustomer /* && currentUser.id === this.customerId */ && this.customerSignature !== null ? true : false;
    return (this.isSubmitted || this.isPending || this.isInRevision) && (!currentUser || !checkUserSigned) ? true : false;
  }

  showRevisionBtn(currentUser: User | null): boolean {
    const checkUserSigned = (currentUser?.isAdmin || currentUser?.isMember) && this.memberSignature !== null ? true :
      currentUser?.isPartner /* && currentUser.id === this.partnerIdP */ && this.partnerSignature !== null ? true :
        currentUser?.isCustomer /* && currentUser.id === this.customerId */ && this.customerSignature !== null ? true : false;
    return (this.isSubmitted || this.isPending || this.isInRevision) && (!currentUser || !checkUserSigned) ? true : false;
  }

  setByForm(rightForm: any) {
    this.status = rightForm.status;
    this.version = rightForm.version.toString();
    this.customerId = rightForm.customer;
    this.partnerId = rightForm.partner;
    return this;
  }

  toAPI() {
    return {
      startDate: this.startDate.toISOString(),
      endDate: this.endDate.toISOString(),
      projectRequestVersionId: this.projectRequestVersionId,
      proposalId: this.proposalId,
      partnerId: this.partnerId,
      customerId: this.customerId,
    };
  }
}



